interface FallbackPanelHandlers {
  /**
   * "Continue in new window" clicked. Runs synchronously inside the click
   * handler so the popup path can call `window.open` under a user gesture.
   */
  onContinue: () => void;
  /** "Dismiss" clicked: close the overlay without continuing. */
  onDismiss: () => void;
}

/**
 * Plain-DOM panel shown when the iframe handshake times out (framing
 * blocked, extension interference, network failure). SDK-rendered on the
 * partner origin, so it can always paint even when the frame cannot.
 */
export function buildFallbackPanel(
  handlers: FallbackPanelHandlers,
): HTMLDivElement {
  const panel = document.createElement('div');
  panel.className = 'cesto-invest-panel';

  const message = document.createElement('p');
  message.className = 'cesto-invest-panel-message';
  message.textContent =
    'The embedded Cesto view could not load in this browser.';

  const continueButton = document.createElement('button');
  continueButton.type = 'button';
  continueButton.className = 'cesto-invest-panel-continue';
  continueButton.textContent = 'Continue in new window';
  continueButton.addEventListener('click', handlers.onContinue);

  const dismissButton = document.createElement('button');
  dismissButton.type = 'button';
  dismissButton.className = 'cesto-invest-panel-dismiss';
  dismissButton.textContent = 'Dismiss';
  dismissButton.addEventListener('click', handlers.onDismiss);

  panel.append(message, continueButton, dismissButton);
  return panel;
}
